<template>
  <div id="app"><router-view /></div>
</template>

<script>
  import Vue from 'vue';
  import Component from 'vue-class-component';

  @Component({
    metaInfo() {
      return {
        title: 'Bigbox',
        meta: [
          {
            name: 'description',
            content:
              'Bigbox - Experiencias únicas para regalar. ' +
              `Regalos de gastronomía, aventura, bienestar o estadías en ${this.$store.countryName}.`,
            vmid: 'description',
          },
          {
            name: 'keywords',
            content: `${this.$store.defaultKeywords} ${this.$store.staticPagesKeywords}`,
            vmid: 'keywords',
          },
          { property: 'og:site_name', content: 'Bigbox', vmid: 'ogSiteName' },
          {
            property: 'og:description',
            content:
              'Bigbox - Experiencias únicas para regalar. ' +
              `Regalos de gastronomía, aventura, bienestar o estadías en ${this.$store.countryName}.`,
            vmid: 'ogDescription',
          },
          {
            property: 'og:image',
            content:
              'http://static.bigbox.com.ar/front/img/logobigbox-192x192.jpg',
            vmid: 'ogImage',
          },
          {
            property: 'og:image:secure_url',
            content:
              'https://static.bigbox.com.ar/front/img/logobigbox-192x192.jpg',
            vmid: 'ogSecureImage',
          },
        ],
      };
    },
  })
  export default class App extends Vue {
    beforeMount() {
      window.addEventListener('resize', () => {
        this.$store.setViewportWidth(window.innerWidth);
      });

      window.addEventListener(
        'message',
        ev => {
          if (ev.origin !== window.location.origin) {
            return;
          }

          const eventHandlers = {
            NAVIGATE_INT: data => this.$router.push(data),
            NAVIGATE_EXT: data => window.open(data, '_blank').focus(),
          };

          if (eventHandlers[ev.data.event]) {
            eventHandlers[ev.data.event](ev.data.data);
          }
        },
        false,
      );
    }
  }
</script>

<style scoped>
  @import '~assets/styles/index.scss';

  .app-root {
    position: relative;
  }
</style>
